module.exports = __webpack_public_path__ + "static/media/YM54_0.0641d7c0.jpg";